import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useApi from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import DispatchSlip from '../components/DispatchSlip';
import { Loader2, Printer } from 'lucide-react';
import Button from '../components/ui/Button';

const DispatchPrint = () => {
  const { id } = useParams();
  const { get } = useApi();
  const { user } = useAuth();
  const [dispatch, setDispatch] = useState(null);
  const [office, setOffice] = useState(null);
  const [loading, setLoading] = useState(true);
  const componentRef = useRef();

  useEffect(() => {
    const fetchDispatch = async () => {
      try {
        const response = await get(`/dispatch/${id}`);
        setDispatch(response.data);
      } catch (error) {
        console.error('Failed to fetch dispatch details:', error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchDispatch();
    }
  }, [id]);

  useEffect(() => {
    const fetchOffice = async () => {
      if (!user?.officeId) return;
      try {
        const response = await get(`/offices/${user.officeId}`);
        setOffice(response.data);
      } catch (e) {
        setOffice(null);
      }
    };
    fetchOffice();
  }, [get, user?.officeId]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (!dispatch) {
    return (
      <div className="flex items-center justify-center min-h-screen text-red-500">
        Dispatch record not found
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-8 print:p-0 print:bg-white">
      <div className="max-w-3xl mx-auto mb-6 flex justify-end print:hidden">
        <Button onClick={handlePrint} icon={Printer}>
          Print Slip
        </Button>
      </div>
      
      <div className="print:w-full print:h-full">
        <DispatchSlip ref={componentRef} dispatch={dispatch} user={user} office={office} />
      </div>

      <style type="text/css" media="print">
        {`
          @page { size: auto; margin: 0mm; }
          body { background-color: white; }
          .print\\:hidden { display: none !important; }
        `}
      </style>
    </div>
  );
};

export default DispatchPrint;
